import React from "react"; 
import {RadioButtonInput } from '../../components/FormInitiators';



const SrFixationForm3 = ({ formData, setFormData, onBack, onNext }) => {
  const handleInputChange = ({ target: { name, value } }) => {
    onFormDataChange({ [name]: value });
  };
  const sLevels = Array.from({ length: 31 }, (_, i) => `S-${i + 1}`);

  return (
  <div className="google_forms">
      <div className="forms">
    <form className="seventh-pay-arrears-form">
        <h3>पदोन्नती पूर्व माहिती </h3>

   
        <label>
          पदोन्नतीपूर्वीचा वेतनस्तर:
          <select
            name="payBandPrevious"
            value={formData.payBandPrevious}
            onChange={handleInputChange}
            className="border px-2 py-1 rounded-md"
          >
            <option value="" disabled>-- Select an option --</option>
            {sLevels.map((level) => (
              <option key={level} value={level}>{level}</option>
            ))}
          </select>
        </label>

      <label>
          पदोन्नतीचा  दिनांक:
        <div style={{ display: "flex", flexDirection: "column" }}>
              <input type="date" name="dateOfPromotion" placeholder="date of birth" value={formData.dateOfPromotion} onChange={handleInputChange}/>
        </div>
      </label>

        <label>
        विकल्प दिनांक:
        <div style={{ display: "flex", flexDirection: "column" }}>
              <input type="date" name="dateOfOption" placeholder="date of birth" value={formData.dateOfOption} onChange={handleInputChange}/>
        </div>
      </label>

        <label>
        विकल्प दिनांकास पदोन्नती पूर्व वेतन स्तरामधील वेतन:
        <input type="number" name="basicPayPrevious" value={formData.basicPayPrevious} onChange={handleInputChange}/>
        </label>

        <label>
        काल्पनीक वेतनवाढ देय आहे काय ? (१)
          </label>
          <label>
                <RadioButtonInput
                  value={formData.notionalIncrement} 
                  onChange={handleInputChange}
                  name="notionalIncrement"  
                  orientation="horizontal"  
                  options={[
                    { value: 'हो', label: 'हो' },
                    { value: 'नाही', label: 'नाही' }
                  ]}         
                />
            
        </label>

        <label>
        पदोन्नतीचा वेतनस्तर:
          <select
              name="payBandPromotion"
              value={formData.payBandPromotion}
              onChange={handleInputChange}
              className="border px-2 py-1 rounded-md"
            >
              <option value="" disabled>-- Select an option --</option>
              {sLevels.map((level) => (
                <option key={level} value={level}>{level}</option>
              ))}
            </select>
        </label>

     
      {/* Navigation Buttons */}
      <div className="seventh-pay-arrears-buttons-container">
        <button type="button" onClick={onBack}>Back</button>
        <button type="button" onClick={onNext}>
         Next
        </button>
      </div>
    </form>
    </div>
    </div>
  );
};

export default SrFixationForm3;
